let wholesaleProducts = `query GetProductsOrProduct(
  $useProduct: Boolean!
  $productId: ID!
  $first: Int = 50
) {
  product(id: $productId) @include(if: $useProduct) {
    id
    title
    handle

    metafields(first: 10, keys: ["price_list_collection"]) {
      edges {
        node {
          namespace
          key
          type
          value
        }
      }
    }

    variants(first: 50) {
      edges {
        node {
          id
          sku
          title
          inventoryItem {
            id
            unitCost {
              amount
            }
          }
          metafields(first: 50) {
            edges {
              node {
                namespace
                key
                type
                value
              }
            }
          }
        }
      }
    }
  }

  products(first: $first) @skip(if: $useProduct) {
    edges {
      node {
        id
        title
        handle
        metafields(first: 10, keys: ["custom.price_list_collection"]) {
          edges {
            node {
              namespace
              key
              type
              value
            }
          }
        }

        variants(first: 50) {
          edges {
            node {
              displayName
              id
              compareAtPrice
              barcode
              price
              title
              sku

              metafields(first: 50) {
                edges {
                  node {
                    namespace
                    key
                    type
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

`;

var collectionDetails=`query GetCollectionPriceListColor($collectionId: ID!) {
  collection(id: $collectionId) {
    id
    title

    metafield(namespace: "custom", key: "price_list_color") {
      id
      namespace
      key
      type
      value
    }
  }
}
`;


var updateTaxExempt = `mutation UpdateCustomerTaxExempt($id: ID!, $taxExempt: Boolean!) {
  customerUpdate(
    input: {
      id: $id
      taxExempt: $taxExempt
    }
  ) {
    customer {
      id
      taxExempt
    }
    userErrors {
      field
      message
    }
  }
}`

var getFullCustomer =`query GetCustomerFull($id: ID!) {
  customer(id: $id) {
    id
    email
    firstName
    lastName
    phone
    taxExempt
    tags
    createdAt
     metafield(namespace: "custom", key: "company_name") {
      id
      value
      key
      type
    }
    addresses {
      id
      company
      address1
      address2
      city
      province
      country
      zip
    }

    
  }
}

`;

var addAddress=`mutation UpdateCustomer($input: CustomerInput!) {
  customerUpdate(input: $input) {
    customer {
      id
      addresses {
        id
        address1
        address2
        city
        province
        zip
        country
        company
      }
    }
    userErrors {
      field
      message
    }
  }
}
`;

var updateAddress=`mutation UpdateCustomerAddress($input: CustomerInput!) {
  customerUpdate(input: $input) {
    customer {
      id
      addresses {
        id
        company
        address1
        address2
        city
        province
        zip
        country
      }
    }
    userErrors {
      field
      message
    }
  }
}`;

var deleteAddressMutation =`mutation UpdateCustomer($input: CustomerInput!) {
  customerUpdate(input: $input) {
    customer {
      id
      addresses {
      company
        id
        address1
        city
        province
        zip
        country
      }
    }
    userErrors {
      field
      message
    }
  }
}
`;

var updateIsMapAcknowledged = `mutation SetMapAcknowledged($input: CustomerInput!) {
  customerUpdate(input: $input) {
    customer {
      id
      metafield(namespace: "custom", key: "ismapacknowledged") {
        id
        key
        value
        type
      }
    }
    userErrors {
      field
      message
    }
  }
}`

var updateCustomerInfoCompany = `
mutation UpdateCustomer($input: CustomerInput!) {
  customerUpdate(input: $input) {
    customer {
      id
      firstName
      lastName
      email
      phone
      taxExempt
      tags

      metafield(namespace: "custom", key: "company_name") {
        id
        value
        type
      }

      addresses {
        id
        company
        address1
        address2
        city
        province
        zip
        country
      }
    }
    userErrors {
      field
      message
    }
  }
}
`;